import { locales } from '@americanexpress/conditional-features';

const {
  EN_US,
  JA_JP,
  EN_IN,
  IT_IT,
} = locales;

export const hasChildAgeDropdownGoToZero = [EN_US];
export const hasChildAgeDropdownMaxEleven = [EN_IN];
export const hasChildAgeJapanUnderTwoLabel = [JA_JP];
export const hasInfantsInLapOnlyRule = [IT_IT];
